/** The record editor's context and its hook, apart from the provider.
 *
 *  The provider resolves each field's widget from the widget registry (`widgetOf`), so it
 *  imports the registry — and a module the registry loads (a widget, the choice question,
 *  the conflict fixes) must not import the provider back. Those take `useRecordEditor`
 *  from here; everything else may keep importing it from `RecordEditorProvider`, which
 *  re-exports it. */
import { createContext, useContext } from 'react';

import type { RecordEditorContextValue } from './RecordEditorProvider';

export const RecordEditorContext = createContext<RecordEditorContextValue | null>(null);

export function useRecordEditor(): RecordEditorContextValue {
  const v = useContext(RecordEditorContext);
  if (!v) throw new Error('useRecordEditor must be used inside <RecordEditorProvider>');
  return v;
}
